import { useLocation, useNavigate, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import logoImg from "@/assets/logo.png";

// Routes where the top bar shows the logo (root tab pages)
const ROOT_ROUTES = new Set<string>([
  "/",
  "/listings",
  "/buyer-dashboard",
  "/seller-dashboard",
  "/professional-dashboard",
  "/list-property",
  "/property-chat",
  "/auth",
]);

const TITLES: Record<string, string> = {
  "/about": "About",
  "/contact": "Contact",
  "/blog": "Blog",
  "/privacy": "Privacy",
  "/professionals": "Professionals",
  "/professional-listings": "Professionals",
  "/concierge": "Concierge",
  "/library": "Library",
  "/claim-home": "Claim Home",
  "/schedule-demo": "Schedule Demo",
  "/buyer-chat": "Messages",
  "/seller-chat": "Messages",
  "/thank-you": "Thanks!",
  "/contact-thank-you": "Thanks!",
};

const MobileTopBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Hide top bar on home and auth pages (they render their own hero/logo)
  if (location.pathname === "/" || location.pathname === "/auth") return null;

  const isRoot = ROOT_ROUTES.has(location.pathname);

  // Resolve title — try exact, then prefix
  let title = TITLES[location.pathname];
  if (!title) {
    const prefix = Object.keys(TITLES).find((k) => location.pathname.startsWith(k + "/"));
    if (prefix) title = TITLES[prefix];
  }
  if (!title && location.pathname.startsWith("/listings/")) title = "Property";
  if (!title && location.pathname.startsWith("/blog/")) title = "Blog";

  return (
    <header
      className="md:hidden sticky top-0 z-40 bg-canvas/95 backdrop-blur-xl border-b border-ink/10"
      style={{ paddingTop: "calc(env(safe-area-inset-top) + 50px)" }}
    >
      <div className="h-12 px-5 flex items-center justify-between">
        {!isRoot ? (
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center w-10 h-10 rounded-full hover:bg-ink/5 active:bg-ink/10 transition-colors text-ink"
            aria-label="Back"
          >
            <ChevronLeft className="w-6 h-6" strokeWidth={2} />
          </button>
        ) : (
          <Link to="/" className="flex items-center -ml-2">
            <img src={logoImg} alt="REALV3" className="h-14 w-auto" />
          </Link>
        )}

        <h1 className="absolute left-1/2 -translate-x-1/2 font-display text-base font-semibold text-ink truncate max-w-[60%]">
          {!isRoot ? title || "" : ""}
        </h1>

        <div className="w-10" />
      </div>
    </header>
  );
};

export default MobileTopBar;
